<div class="form-control-margin">
  <stx-checkbox-group layoutDirection="column" [formGroup]="formGroupReference" [options]="speechOptions"></stx-checkbox-group>
</div>
